import React, {Fragment, MutableRefObject, useEffect, useRef} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {sizeChanged} from './actions/window'
import registerListener from './helper/registerListener'
import unregisterListener from './helper/unregisterListener'
import Header from './components/Header'
import CTAMessage from './components/CTAMessage'
import BrandRow from './components/BrandRow'
import Column from './components/Column'
import BlueBox from './components/BlueBox'
import styleMain from './scss/Main.module.scss'
import { Fade } from "react-awesome-reveal"
import ExplainedKeypoints from './components/ExplainedKeypoints'
import HeroSeller from './components/HeroSeller'
import SimpleKeypoints from './components/SimpleKeypoints'
import Testimonial from './components/Testimonial'
import Tooltip from './components/Tooltip'
import BlueCTASection from './components/BlueCTASection'
import Footer from './components/Footer'
import FAQ from './components/FAQ'
import targetAnimatedImg from './assets/target-animated.png'
import rocketAnimatedImg from './assets/rocket-animated.png'
import ideaAnimatedImg from './assets/idea-animated.png'
import FreeLessonVideo from "./components/FreeLessonVideo"
import SeminarImages from "./components/SeminarImages"
import Guarantee from "./components/Guarantee"
import classNames from "classnames"
import {setUserLoggedIn} from "./actions/user"

const App = () => {
    // @ts-ignore
    const width = useSelector(state => state.window.width)
    const dispatch = useDispatch()
    let controlledResizeTimeout: MutableRefObject<any> = useRef()

    useEffect(() => {
        fetch(process.env.REACT_APP_USER_CHECK_URL as string, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            credentials: 'include',
            redirect: 'error'
        })
            .then(response => {
                if (response.status !== 200) {
                    throw new Error(response.statusText)
                } else {
                    dispatch(setUserLoggedIn(true))
                }
            })
            .catch(error => {
                dispatch(setUserLoggedIn(false))
            })

        const afterResize = () => {
            if (controlledResizeTimeout.current)
                controlledResizeTimeout.current = clearTimeout(controlledResizeTimeout.current)

            controlledResizeTimeout.current = setTimeout(() => {
                dispatch(sizeChanged())
            }, 50)
        }

        registerListener('resize', afterResize)

        return () => {
            unregisterListener('resize', afterResize)
        }
    })

    return (
        <Fragment>
            {width > 800 ? (
                <Fragment>
                    <div className={'LeftCircle'}/>
                    <div className={'RightCircle'}>
                        <div className={'AsBorder'}/>
                    </div>
                    <div className={classNames('LeftCircle', 'LeftCircleBottom')}/>
                    <div className={classNames('RightCircle', 'RightCircleBottom')}>
                        <div className={'AsBorder'}/>
                    </div>
                </Fragment>
            ) : null}
            <Header/>
            <CTAMessage/>
            <div className={styleMain.Container}>
                <BrandRow>
                    <Column>
                        <Fade direction={'up'} triggerOnce={true}>
                            <BlueBox img={targetAnimatedImg} img_size={{
                                width: 150,
                                height: 150,
                            }} title={'Keskendu vaid 3-le kõige tähtsamale küsimusele'}>
                                Igal salongiomanikul on ööpäevas võrdne arv tunde. Mis muudab aga ühe salongi teisest edukamaks on teadmine,
                                mis on suures pildis tegelikult tähtis ning millele oma energiat ja fookust suunata.
                            </BlueBox>
                        </Fade>
                    </Column>
                    <Column>
                        <Fade direction={'up'} triggerOnce={true}>
                            <BlueBox img={rocketAnimatedImg} img_size={{
                                width: 126,
                                height: 126,
                            }} title={'Ideaalne klienditeekond ehk salajane 75 mudel'}>
                                75 mudel on n-ö linnulennuline vaade Sinu kliendi teekonnale.
                                Kui Sa tead kõiki seitset osa sellest ja mis taktikaid ühel või teisel hetkel rakendada,
                                ei pea Sa enam kunagi muretsema uute klientide leidmise, püsiklientide hoidmise või käibe kasvatamise pärast.
                            </BlueBox>
                        </Fade>
                    </Column>
                    <Column>
                        <Fade direction={'up'} triggerOnce={true}>
                            <BlueBox img={ideaAnimatedImg} img_size={{
                                width: 140,
                                height: 140,
                            }} title={'60+ kuulikindlat salongi kasvatamise taktikat'}>
                                Kui oled avastanud 3 tähtsaimat küsimust ja 7 salajast komponenti ideaalsest klienditeekonnast,
                                on salongiga seotud unistuste täitumisest puudu veel vaid õiged taktikad. Need Sa ka SalonSecretsist leiad.
                            </BlueBox>
                        </Fade>
                    </Column>
                </BrandRow>
                <FreeLessonVideo />
                <ExplainedKeypoints/>
                <HeroSeller/>
                <SimpleKeypoints/>
                <Testimonial/>
            </div>
                <SeminarImages />
            <div className={styleMain.Container}>
                <Tooltip/>
            </div>
            <BlueCTASection/>
            <div className={styleMain.Container}>
                <Guarantee/>
                <FAQ/>
                <Footer/>
            </div>
        </Fragment>
    )
}

export default App
